import { IData } from '../interface';

/**
 * @desc 统一监控SDK
 * - logger.info({ msg, trace, ext })  采样上报
 * - logger.infoAll({ msg, trace, ext }) 全量上报
 * - logger.error({ msg, trace, ext })
 * - logger.report({ msg, level, trace, ext })
 * - CN站点统一到Rum平台上报，支持
 * rum: https://cloud.tencent.com/document/product/1464/58562
 */

const loggerTpl = `
var noop = function(params) {console.log(params);};
window.logger = { report: noop, info: noop, infoAll: noop, error: noop};
`

const monitorTpl = `
<script>
   ${loggerTpl}
   (function() {
       function loadScript(url, successCallback, counter) {
           var script = document.createElement('script');
           script.src = url;
           script.onload = function () {
               successCallback();
           };
           script.onerror = function () {
               if (counter > 0) {
                   setTimeout(function () {
                       loadScript(url, successCallback, counter - 1);
                   }, 500);
               }
           };
           document.head.appendChild(script);
       }

       var env = 'PD';
       var uid = '0_0';
       var system = 'CN';
       var version = window.version || 0;
       var tokenMap = {
           ONLINE: 'aZa6RfDQoRO7bvWPkx',
           PD: 'mZ98eHLW5ajZ3DQ5PW'
       };

       var aegisUrl = 'https://cdn-go.cn/aegis/aegis-sdk/latest/aegis.min.js';

       // 获取初始化数据
       const getPageData = function() {
           if (!window.pageData) return;
           var pageData = window.pageData;
           env = ((pageData.config || {}).env || 'PD').toUpperCase();
           system = ((pageData.config || {}).system || 'CN').toUpperCase();
           var data = pageData.data || {};
           var info = data.teacher_info || data.user_info || { enterprise_id:0 , umu_id: 0 };
           uid = (info.enterprise_id || info.enterpriseId || '0') + '_' + info.umu_id;
       }
       loadScript(
           aegisUrl,
           function () {
               getPageData();
               if (system != 'CN') {
                   return;
               }
               var token = tokenMap[env];
               if (!token) return;
               if (window.Aegis) {
                   window.aegis = new Aegis({
                       id: token, // 上报 id
                       env: env,
                       version: version,
                       offlineLog: true,
                       random: 0.1, // 采样率
                       speedSample: 0.1, // 接口测速采样
                       uin: uid, // 用户ID
                       reportApiSpeed: true, // 接口测速
                       reportAssetSpeed: true, // 静态资源测速
                       spa: true // spa 应用页面跳转的时候开启 pv 计算
                   });
                   window.logger = window.aegis; // 统一上报api
               }
           },
           1
       );
   })();
</script>
`;


export default function(data: IData) {
    if (data.SYSTEM === 'CN') {
        return monitorTpl;      
    }
    return `<script>${loggerTpl}</script>`;
}